import Index from 'src/pages/Units/Index.vue'
import Create from 'src/pages/Units/Create.vue'
import Edit from 'src/pages/Units/Edit.vue'

const auth = { requiresAuth: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/units',
    name: 'Einheiten',
    component: Index,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/units/create',
    name: 'Einheit Erstellen',
    component: Create,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/units/:id/edit',
    name: 'Einheit Bearbeiten',
    component: Edit,
    meta: { ...auth, ...notUser }
  }
]
